<template>
  <div class="home">
    <div>
      <img class="banner" src="@/assets/banner.jpg" />
    </div>
    <h1>能为你提供哪些服务</h1>
    <div class="image-row">
      <div v-for="(item, index) in images" :key="index" class="image-item">
        <img :src="item.src" :alt="item.alt" class="image">
        <div class="description">{{ item.description }}</div>
      </div>
    </div>
    <h1>你的智能AI助手</h1>
    <xunfei />
  </div>
</template>

<script>
// @ is an alias to /src
import xunfei from './Xunfei';

export default {
  name: 'HomeView',
  components: {
    xunfei
  },
  data() {
    return {
      images: [
        {
          src: require('@/assets/app.jpeg'),
          alt: 'APP 开发',
          description: 'APP 开发'
        },
        {
          src: require('@/assets/site.jpeg'),
          alt: '网站开发',
          description: '网站开发'
        },
        {
          src: require('@/assets/mini.jpeg'),
          alt: '小程序开发',
          description: '小程序开发'
        },
        {
          src: require('@/assets/custom.jpeg'),
          alt: '定制开发',
          description: '定制开发'
        }
      ]
    };
  }
}
</script>

<style scoped>
.banner {
  width: 100%;
}

.image-row {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap; /* 允许换行 */
  margin-bottom: 20px;
}

.image-item {
  width: 23%; /* 四张图片加空隙占满100%，每张图片占23%左右 */
  margin: 0 1%;
  text-align: center; /* 文字居中对齐 */
}

.image {
  max-width: 100%;
  height: auto;
  border: 1px solid #ddd; /* 可选边框 */
}

.description {
  margin-top: 5px; /* 描述与图片之间的间距 */
  font-size: 1.8em; /* 描述文字大小 */
  color: #666; /* 描述文字颜色 */
}
</style>
